import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { PERMISSIONS } from '../../../constants/index';
import CustomButton from "../../../components/CustomButton";

type ContentType = {
  name: 'notification' | 'news';
  label: string;
};

type Content = {
  type: ContentType;
  date: string;
  title: string;
  tags: [];
  action: any;
};

const typeBgColorMapping = {
  notification: "bg-alu-primary",
  news: "bg-alu-tag",
  job: "bg-alu-tag",
};

const ContentItem = ({ content }: { content: Content }) => {
  const typeBgColor = typeBgColorMapping[content.type.name];

  return (
    <div className="py-2 flex flex-col gap-1 md:gap-2 border-b border-[#E0E0E0]">
      <p className="text-sm leading-[1.3125rem] alu-text-base-2">
        {content.date}
      </p>
      <div className="flex flex-wrap items-center gap-1">
        <div
          className={`py-[0.125rem] px-2 ${typeBgColor} font-bold leading-[1.125rem] text-xs text-white rounded`}
        >
          {content.type?.label}
        </div>
        {content.tags.length > 0 &&
            content.tags.map((tag: any, idx: any) => (
              <span
                key={idx}
                className="shrink-0 py-[0.125rem] px-[0.375rem] rounded border border-[#808080] bg-white text-[#808080] font-bold leading-[1.125rem] text-xs"
              >
                {tag}
              </span>
            ))
        }
      </div>
      <h5 
        className="xl:block hidden font-bold text-base alu-text-base-2 hover:cursor-pointer text-link-with-hover w-fit break-words break-all"
        onClick={() => content.action()}
      >
        {content.title}
      </h5>
      <h5 
        className="xl:hidden font-bold text-base alu-text-base-2 hover:cursor-pointer text-link-with-hover w-fit break-words break-all line-clamp-1"
        onClick={() => content.action()}
      >
        {content.title}
      </h5>
    </div>
  );
};

const ContentNotification = ({ contentList }: any) => {
  const navigate = useNavigate();
  const currentUser = useSelector((state: any) => state.currentUser);
  const { staffPermission } = currentUser;
  const { menu } = useSelector((state: any) => state.companyContentManage);

  return (
    <>
      <div className="flex items-center mb-4">
        <h1 className="text-xl font-bold leading-[1.875rem] alu-text-base-2">
          お知らせ
        </h1>
        {staffPermission[PERMISSIONS.NEWS_NOTI_SETTING] && (
        <CustomButton
          type="button"
          variant="outline"
          customStyle="ml-8"
          onClick={() => navigate("/company/notification-setting")}
          size="sm"
        >
          お知らせ枠を管理
        </CustomButton>
        )}
      </div>
      <div className="p-6 bg-white rounded-2xl alu-section-box-shadow">
        {contentList.map((content: any, idx: any) => (
          <ContentItem key={idx} content={content} />
        ))}
      </div>
    </>
  );
};

export default ContentNotification;
